<template>
    <ProjectDialog :project="getCurrentProject" />
</template>

<script>
import ProjectDialog from '@/components/project module/ProjectDialog.vue';
import { ref, reactive } from 'vue';

export default {
    name: 'ProjectView',
    components: {
        ProjectDialog,
    },
    computed: {
        getCurrentProject() {
            console.log("currentProject", this.$store.getters.currentProject);
            return this.$store.getters.currentProject;
        }
    }
}
</script>

<style></style>